export enum PlanType {
  free = "フリー",
  light = "ライト",
  starter = "スタンダード",
  premium = "プレミアム",
  enterprise = "エンタープライズ",
}
